// The care-staffing facts about one staff member, read by the clinician details
// page (for any staff member, managers and admins) and by the staff member's own
// profile: whether they are a care specialist at all, their clinical role,
// bookability, default pool, coverage, licences and prescriber details with the
// pharmacy-readiness verdict. Keyed by internal user rather than specialist,
// because both pages start from the staff member.

import { z } from 'zod';
import { apiEnvelope } from '../envelope';
import { ClinicianRole } from '../programs/schema';
import {
  careSpecialistCoverageSchema,
  careSpecialistLicenceReadSchema,
  dropRosterCoverageWithUnroutableCallTypes,
} from './care-call-types';
import { careStaffingPrescriberDetailsDataSchema } from './prescriber-details';

export const careStaffingSpecialistSummarySchema = z.object({
  specialistId: z.string().uuid(),
  clinicalRole: ClinicianRole,
  /** `care_specialists.active`: false revokes bookability. */
  active: z.boolean(),
  defaultPool: z.boolean(),
  coverage: z.preprocess(
    dropRosterCoverageWithUnroutableCallTypes,
    z.array(careSpecialistCoverageSchema),
  ),
  licences: z.array(careSpecialistLicenceReadSchema),
  prescriberDetails: careStaffingPrescriberDetailsDataSchema,
});
export type CareStaffingSpecialistSummary = z.infer<typeof careStaffingSpecialistSummarySchema>;

export const careStaffingSpecialistSummaryDataSchema = z.object({
  /** Null when the staff member is not a care specialist. */
  specialist: careStaffingSpecialistSummarySchema.nullable(),
});
export type CareStaffingSpecialistSummaryData = z.infer<
  typeof careStaffingSpecialistSummaryDataSchema
>;
export const careStaffingSpecialistSummaryResponseSchema = apiEnvelope(
  careStaffingSpecialistSummaryDataSchema,
);
